const LOCALE_ALIASES = {
  'en-gb': 'en',
  'en-us': 'en',
  'en-nl': 'en',
  'en-ie': 'en',
  'en-ca': 'en',
  'en-au': 'en',
  'en-de': 'en',
  'en-fr': 'en',
  'fr-fr': 'fr',
  'fr-be': 'fr',
  'fr-ca': 'fr',
  'de-de': 'de',
  'de-at': 'de',
  'de-ch': 'de',
}

function normaliseLocale (raw) {
  if (!raw) return 'en'
  const key = raw.toLowerCase().trim()
  if (LOCALE_ALIASES[key]) return LOCALE_ALIASES[key]
  return key.split('-')[0] || 'en'
}

function escapeHtml (value) {
  if (value === null || value === undefined) return ''
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function starRowHtml (rating, size = 'w-4 h-4') {
  const full = Math.floor(rating)
  const empty = Math.max(0, 5 - full)
  const starFull = '<svg viewBox="0 0 24 24" fill="currentColor" class="w-full h-full" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"/></svg>'
  const starEmpty = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-full h-full" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"/></svg>'
  let html = ''
  for (let i = 0; i < full; i += 1) {
    html += `<span class="inline-block ${size}">${starFull}</span>`
  }
  for (let i = 0; i < empty; i += 1) {
    html += `<span class="inline-block ${size} text-clay">${starEmpty}</span>`
  }
  return html
}

const CHECK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" class="w-full h-full" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"/></svg>'

const PHOTO_SPINNER_HTML = '<span class="product-reviews__card-image__spinner absolute inset-0 hidden items-center justify-center bg-white/80" aria-hidden="true"><span class="inline-block w-5 h-5 border-2 border-iron/30 border-t-army rounded-full animate-spin"></span></span>'

function formatDate (iso) {
  if (!iso) return ''
  try {
    const d = new Date(iso)
    if (Number.isNaN(d.getTime())) return ''
    return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })
  } catch {
    return ''
  }
}

const I18N_FALLBACKS = {
  verifiedBuyer: 'Verified buyer',
  sourceBadge: 'Review from [[source]]',
  defaultAuthor: 'Verified buyer',
  defaultReplyAuthor: 'TentBox',
  openPhotoAria: 'Open review photo',
  loadingPhoto: 'Loading photo',
  starsAria: '[[rating]] out of 5 stars',
  loadingList: 'Loading reviews…',
  loadingButton: 'Loading…',
  errorLabel: 'Could not load more reviews.',
  errorRetry: 'Try again',
  loadMoreLabel: 'Load more reviews',
  loadMoreCount: '([[count]] more)',
}

function interpolate (template, values) {
  if (!template) return ''
  return String(template).replace(/\[\[(\w+)\]\]/g, (_, key) => {
    const value = values ? values[key] : undefined
    if (value === undefined || value === null) return ''
    return String(value)
  })
}

function reviewRating (review) {
  const value = Number(review?.rating)
  return Number.isFinite(value) ? value : 0
}

function reviewOrderKey (review) {
  if (review?.id !== null && review?.id !== undefined && review.id !== '') return String(review.id)
  return `${review?.author || ''}|${review?.created || ''}|${String(review?.content || '').slice(0, 40)}`
}

class TbProductReviews extends HTMLElement {
  constructor () {
    super()
    this.handleHostClick = this.handleHostClick.bind(this)
    this.handleSectionLoad = this.handleSectionLoad.bind(this)
  }

  connectedCallback () {
    if (!this._hostEventsBound) {
      this._hostEventsBound = true
      this.addEventListener('click', this.handleHostClick)
      document.addEventListener('shopify:section:load', this.handleSectionLoad)
    }

    if (this._reviewsReady) {
      this.refreshDomRefs()
      return
    }

    const jsonEl = this.querySelector('script[type="application/json"][data-reviews-json]')
    if (!jsonEl) return

    this._reviewsReady = true

    try {
      let parsed = JSON.parse(jsonEl.textContent || '{}')
      if (typeof parsed === 'string') {
        parsed = JSON.parse(parsed)
      }
      if (Array.isArray(parsed.reviews)) {
        this.seedReviews = parsed.reviews
      } else if (Array.isArray(parsed)) {
        this.seedReviews = parsed
      } else {
        this.seedReviews = []
      }
    } catch (err) {
      console.warn('[tb-product-reviews] Failed to parse reviews JSON:', err)
      this.seedReviews = []
    }

    const i18nEl = this.querySelector('script[type="application/json"][data-reviews-i18n]')
    let i18nFromDom = {}
    if (i18nEl) {
      try {
        i18nFromDom = JSON.parse(i18nEl.textContent || '{}')
      } catch (err) {
        console.warn('[tb-product-reviews] Failed to parse i18n JSON:', err)
      }
    }
    this.i18n = { ...I18N_FALLBACKS, ...i18nFromDom }

    const documentLang = (document.documentElement.lang || this.dataset.locale || 'en').toLowerCase()
    this.locale = normaliseLocale(documentLang)
    this.initialCount = Math.max(1, parseInt(this.dataset.initialCount || '6', 10))
    this.pageSize = Math.max(1, parseInt(this.dataset.pageSize || '6', 10))
    this.total = parseInt(this.dataset.total || '0', 10) || 0
    this.hasMoreOnServer = this.dataset.hasMore === 'true'
    this.appUrl = (this.dataset.appUrl || '').replace(/\/$/, '')
    this.store = this.dataset.store || ''
    this.productId = this.dataset.productId || ''
    this.canPaginateApi = Boolean(this.hasMoreOnServer && this.appUrl && this.store && this.productId)
    this.languageControl = this.dataset.languageControl || 'none'

    const defaultLanguageFilter = this.languageControl === 'toggle' ? this.locale : 'all'
    this.state = {
      languageFilter: defaultLanguageFilter,
      visible: this.initialCount,
      apiCursor: null,
      apiExhausted: false,
      loading: false,
    }

    this.apiReviews = []
    this.knownIds = new Set(this.seedReviews.map(r => r.id).filter(Boolean))

    this.listEl = this.querySelector('[data-review-list]')
    this.emptyEl = this.querySelector('[data-empty]')
    this.loadMoreBtn = this.querySelector('[data-load-more]')
    this.loadMoreLabelEl = this.querySelector('[data-load-more-label]')
    this.loadMoreCountEl = this.querySelector('[data-load-more-count]')
    this.loadMoreDefaultLabel = this.loadMoreLabelEl
      ? this.loadMoreLabelEl.textContent.trim() || this.i18n.loadMoreLabel
      : this.i18n.loadMoreLabel
    this.langSelect = this.querySelector('[data-review-language-select]')
    this.langOnlyInput = this.querySelector('[data-lang-only]')
    this.langLabelOnly = this.querySelector('[data-lang-label-only]')
    this.langLabelAll = this.querySelector('[data-lang-label-all]')
    this.resetBtn = this.querySelector('[data-reset]')

    const ssrCardCount = this.listEl ? this.listEl.querySelectorAll('[data-review-id]').length : 0

    if (this.seedReviews.length === 0 && ssrCardCount > 0) {
      this.hydrateSeedFromDom()
    }

    this.bindControlEvents()

    if (this.langOnlyInput && this.languageControl === 'toggle') {
      this.updateToggleLabel()
    }

    if (this.seedReviews.length > 0) {
      this.render()
    }
  }

  disconnectedCallback () {
    this._reviewsReady = false
  }

  refreshDomRefs () {
    this.listEl = this.querySelector('[data-review-list]')
    this.emptyEl = this.querySelector('[data-empty]')
    this.loadMoreBtn = this.querySelector('[data-load-more]')
    this.loadMoreLabelEl = this.querySelector('[data-load-more-label]')
    this.loadMoreCountEl = this.querySelector('[data-load-more-count]')
    this.langSelect = this.querySelector('[data-review-language-select]')
    this.langOnlyInput = this.querySelector('[data-lang-only]')
    this.langLabelOnly = this.querySelector('[data-lang-label-only]')
    this.langLabelAll = this.querySelector('[data-lang-label-all]')
    this.resetBtn = this.querySelector('[data-reset]')
  }

  handleSectionLoad (event) {
    if (!this.state) return
    const section = this.closest('.shopify-section')
    if (!section || event.detail?.sectionId !== this.dataset.sectionId) return

    this.refreshDomRefs()
    if (this.langOnlyInput && this.languageControl === 'toggle') {
      this.updateToggleLabel()
    }
    this.render()
  }

  handleHostClick (event) {
    const photoLink = event.target.closest('.product-reviews__card-image')
    if (!photoLink) return
    if (photoLink.classList.contains('product-reviews__card-image--loading')) return

    const src = photoLink.dataset.imageSrc || photoLink.getAttribute('href')
    if (!src) return

    if (document.querySelector('.reusable-modal')) {
      event.preventDefault()
      this.openPhotoModal(photoLink, src)
    }
  }

  hydrateSeedFromDom () {
    if (!this.listEl) return

    const cards = this.listEl.querySelectorAll('[data-review-id]')
    if (!cards.length) return

    this.seedReviews = Array.from(cards).map(card => {
      const timeEl = card.querySelector('time')
      return {
        id: card.dataset.reviewId,
        rating: Number(card.dataset.reviewRating) || 0,
        lang: card.dataset.reviewLang || 'und',
        verified: card.dataset.reviewVerified === 'true',
        created: timeEl?.getAttribute('datetime') || '',
        title: card.querySelector('.product-reviews__card-title')?.textContent?.trim() || '',
        content: card.querySelector('.product-reviews__card-content')?.textContent?.trim() || '',
        author: card.querySelector('.product-reviews__card-author')?.textContent?.trim() || '',
      }
    })

    this.knownIds = new Set(this.seedReviews.map(review => review.id).filter(Boolean))
  }

  bindControlEvents () {
    if (this._controlEventsBound) return
    this._controlEventsBound = true

    this.addEventListener('change', (event) => {
      const langSelect = event.target.closest('[data-review-language-select]')
      if (langSelect && this.contains(langSelect)) {
        this.langSelect = langSelect
        this.state.languageFilter = langSelect.value || 'all'
        this.resetAndRender()
        return
      }

      const langOnlyInput = event.target.closest('[data-lang-only]')
      if (langOnlyInput && this.contains(langOnlyInput)) {
        this.langOnlyInput = langOnlyInput
        this.state.languageFilter = langOnlyInput.checked ? this.locale : 'all'
        this.updateToggleLabel()
        this.resetAndRender()
      }
    })

    this.addEventListener('click', (event) => {
      const resetBtn = event.target.closest('[data-reset]')
      if (resetBtn && this.contains(resetBtn)) {
        this.resetBtn = resetBtn
        this.state.languageFilter = 'all'
        if (this.langSelect) this.langSelect.value = 'all'
        if (this.langOnlyInput) this.langOnlyInput.checked = false
        this.updateToggleLabel()
        this.resetAndRender()
        return
      }

      const loadMoreBtn = event.target.closest('[data-load-more]')
      if (loadMoreBtn && this.contains(loadMoreBtn)) {
        this.loadMoreBtn = loadMoreBtn
        this.handleLoadMore()
      }
    })
  }

  updateToggleLabel () {
    if (!this.langLabelOnly || !this.langLabelAll || !this.langOnlyInput) return
    if (this.langOnlyInput.checked) {
      this.langLabelOnly.classList.remove('hidden')
      this.langLabelAll.classList.add('hidden')
    } else {
      this.langLabelOnly.classList.add('hidden')
      this.langLabelAll.classList.remove('hidden')
    }
  }

  hasActiveFilters () {
    return this.languageControl !== 'none' && this.state.languageFilter !== 'all'
  }

  applyClientFilters (rows) {
    const { languageFilter } = this.state
    let out = rows.slice()

    if (this.languageControl !== 'none' && languageFilter !== 'all') {
      out = out.filter(r => {
        const lang = (r.lang || 'und').toLowerCase()
        return lang === languageFilter || lang === 'und'
      })
    }

    return out
  }

  resetAndRender () {
    this.state.visible = this.initialCount
    this.state.apiCursor = null
    this.state.apiExhausted = false
    this.render()
  }

  getAllRows () {
    const byKey = new Map()
    for (const review of [...this.seedReviews, ...this.apiReviews]) {
      byKey.set(reviewOrderKey(review), review)
    }
    return Array.from(byKey.values())
  }

  render () {
    const allRows = this.getAllRows()
    const filtered = this.applyClientFilters(allRows)
    const visibleCount = Math.min(filtered.length, this.state.visible)
    const slice = filtered.slice(0, visibleCount)

    this.renderList(slice, { loading: this.state.loading })

    if (filtered.length === 0 && !this.state.loading) {
      this.showEmpty(true)
    } else {
      this.showEmpty(false)
    }

    const clientHasMore = filtered.length > visibleCount
    const serverHasMore = this.canPaginateApi && !this.state.apiExhausted
    const showLoadMore = clientHasMore || serverHasMore

    if (this.loadMoreBtn) {
      this.loadMoreBtn.hidden = !showLoadMore
      if (this.loadMoreCountEl) {
        if (clientHasMore) {
          this.loadMoreCountEl.textContent = interpolate(this.i18n.loadMoreCount, { count: filtered.length - visibleCount })
        } else {
          this.loadMoreCountEl.textContent = ''
        }
      }
      if (this.loadMoreLabelEl) {
        this.loadMoreLabelEl.textContent = this.state.loading ? this.i18n.loadingButton : this.loadMoreDefaultLabel
      }
      this.loadMoreBtn.disabled = !!this.state.loading
    }
  }

  renderList (rows, { loading }) {
    if (loading && rows.length === 0) {
      this.listEl.innerHTML = `<div class="product-reviews__loading text-center text-iron py-6">${escapeHtml(this.i18n.loadingList)}</div>`
      return
    }
    this.listEl.innerHTML = rows.map(r => this.renderCard(r)).join('')
  }

  showEmpty (show) {
    if (!this.emptyEl) return
    if (show) {
      this.emptyEl.classList.remove('hidden')
      this.emptyEl.classList.add('flex', 'flex-col', 'items-center')
    } else {
      this.emptyEl.classList.add('hidden')
      this.emptyEl.classList.remove('flex', 'flex-col', 'items-center')
    }
  }

  renderError (err) {
    console.error('[tb-product-reviews] load failed', err)
    this.state.loading = false
    if (this.listEl) {
      this.listEl.innerHTML = `<div class="product-reviews__error text-center text-iron py-6">${escapeHtml(this.i18n.errorLabel)} <button type="button" class="underline hover:text-army" data-retry>${escapeHtml(this.i18n.errorRetry)}</button></div>`
      const retry = this.listEl.querySelector('[data-retry]')
      if (retry) {
        retry.addEventListener('click', () => this.resetAndRender())
      }
    }
  }

  async handleLoadMore () {
    const filtered = this.applyClientFilters(this.getAllRows())
    const currentlyShown = Math.min(filtered.length, this.state.visible)
    const clientHasMore = filtered.length > currentlyShown

    if (clientHasMore) {
      this.state.visible = Math.min(filtered.length, currentlyShown + this.pageSize)
      this.render()

      const remaining = filtered.length - this.state.visible
      const needMoreFromApi = this.canPaginateApi && !this.state.apiExhausted && remaining < this.pageSize
      if (needMoreFromApi) {
        try { await this.fetchApiPage() } catch (err) { console.warn('[tb-product-reviews] prefetch failed', err) }
        this.render()
      }
      return
    }

    if (this.canPaginateApi && !this.state.apiExhausted) {
      this.state.loading = true
      this.render()
      try {
        await this.fetchApiPage()
        this.state.visible += this.pageSize
      } catch (err) {
        this.renderError(err)
        return
      } finally {
        this.state.loading = false
      }
      this.render()
    }
  }

  buildApiUrl () {
    const params = new URLSearchParams()
    params.set('store', this.store)
    params.set('limit', String(Math.max(this.pageSize, 24)))
    params.set('sort', 'recent')

    if (this.state.apiCursor) params.set('cursor', this.state.apiCursor)

    if (this.languageControl !== 'none' && this.state.languageFilter !== 'all') {
      params.set('lang', this.state.languageFilter)
    }

    if (!this.state.apiCursor && !this.hasActiveFilters() && this.knownIds.size > 0) {
      const ids = Array.from(this.knownIds).slice(0, 200).join(',')
      if (ids) params.set('exclude_ids', ids)
    }

    return `${this.appUrl}/api/storefront/klaviyo-reviews/${encodeURIComponent(this.productId)}?${params.toString()}`
  }

  async fetchApiPage () {
    if (this.state.apiExhausted || !this.canPaginateApi) return

    const res = await fetch(this.buildApiUrl(), {
      headers: { Accept: 'application/json' },
      credentials: 'omit',
    })
    if (!res.ok) throw new Error(`HTTP ${res.status}`)

    const contentType = res.headers.get('content-type') || ''
    if (!contentType.includes('application/json')) {
      throw new Error('Non-JSON response')
    }

    const json = await res.json()
    const incoming = Array.isArray(json.reviews) ? json.reviews : []
    for (const r of incoming) {
      if (!this.knownIds.has(r.id)) {
        this.knownIds.add(r.id)
        this.apiReviews.push(r)
      }
    }
    this.state.apiCursor = json.next_cursor || null
    if (!this.state.apiCursor) {
      this.state.apiExhausted = true
    }
  }

  renderCard (review) {
    const full = Math.floor(reviewRating(review))
    const title = review.title ? `<h3 class="product-reviews__card-title text-lg font-semibold mb-1">${escapeHtml(review.title)}</h3>` : ''
    const content = review.content ? `<p class="product-reviews__card-content text-iron leading-relaxed whitespace-pre-line">${escapeHtml(review.content)}</p>` : ''

    let verifiedBadge = ''
    if (review.verified) {
      verifiedBadge = `<span class="product-reviews__card-badge select-none inline-flex items-center gap-1 text-xs text-army bg-army/10 rounded-full px-2 py-0.5"><span class="inline-block w-3 h-3">${CHECK_ICON}</span>${escapeHtml(this.i18n.verifiedBuyer)}</span>`
    }

    let sourceBadges = ''
    if (Array.isArray(review.badges)) {
      sourceBadges = review.badges.map(badge => {
        const label = badge.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
        const text = interpolate(this.i18n.sourceBadge, { source: label })
        return `<span class="product-reviews__card-badge product-reviews__card-badge--source inline-flex items-center gap-1 text-xs text-iron bg-oat rounded-full px-2 py-0.5">${escapeHtml(text)}</span>`
      }).join('')
    }

    let imagesHtml = ''
    if (Array.isArray(review.images) && review.images.length > 0) {
      const openPhotoAria = escapeHtml(this.i18n.openPhotoAria)
      imagesHtml = `<div class="product-reviews__card-images flex flex-wrap gap-2 mt-3">${review.images.map(img => {
        const thumb = img && typeof img === 'object' && img.thumb ? img.thumb : ''
        const fullImage = img && typeof img === 'object' && img.full ? img.full : thumb
        if (!thumb) return ''
        return `<a href="${escapeHtml(fullImage)}" class="product-reviews__card-image relative block w-16 h-16 rounded overflow-hidden border border-iron/20 focus:outline-hidden focus:ring-2 focus:ring-army" data-image-src="${escapeHtml(fullImage)}" target="_blank" rel="noopener" aria-label="${openPhotoAria}"><img src="${escapeHtml(thumb)}" alt="" width="300" height="300" loading="lazy" decoding="async" class="product-reviews__card-image-thumb w-full h-full object-cover">${PHOTO_SPINNER_HTML}</a>`
      }).join('')}</div>`
    }

    let replyHtml = ''
    if (review.public_reply && review.public_reply.content) {
      const replyAuthor = review.public_reply.author || this.i18n.defaultReplyAuthor
      replyHtml = `<div class="product-reviews__card-reply mt-4 p-3 rounded bg-oat text-sm"><div class="product-reviews__card-reply-author font-semibold mb-1">${escapeHtml(replyAuthor)}</div><p class="product-reviews__card-reply-content whitespace-pre-line">${escapeHtml(review.public_reply.content)}</p></div>`
    }

    const author = review.author || this.i18n.defaultAuthor
    const dateText = formatDate(review.created)
    const lang = (review.lang || 'und').toLowerCase()
    const starsAria = interpolate(this.i18n.starsAria, { rating: reviewRating(review) })

    return `<article class="product-reviews__card rounded-lg border border-iron/20 p-4 md:p-5 bg-white" data-review-id="${escapeHtml(review.id)}" data-review-lang="${lang}" data-review-rating="${reviewRating(review)}" data-review-has-photos="${Array.isArray(review.images) && review.images.length > 0}" data-review-verified="${review.verified === true}">
      <header class="product-reviews__card-header flex flex-wrap items-center gap-2 mb-2">
        <div class="product-reviews__card-stars flex items-center text-gold h-4" role="img" aria-label="${escapeHtml(starsAria)}">
          ${starRowHtml(full)}
        </div>
        ${verifiedBadge}
        ${sourceBadges}
      </header>
      ${title}
      ${content}
      ${imagesHtml}
      <footer class="product-reviews__card-footer flex items-center justify-between mt-3 text-xs text-iron">
        <span class="product-reviews__card-author">${escapeHtml(author)}</span>
        <time datetime="${escapeHtml(review.created || '')}" class="product-reviews__card-date">${dateText}</time>
      </footer>
      ${replyHtml}
    </article>`
  }

  setPhotoLinkLoading (photoLink, loading) {
    if (!photoLink) return
    photoLink.classList.toggle('product-reviews__card-image--loading', loading)
    if (loading) {
      photoLink.setAttribute('aria-busy', 'true')
    } else {
      photoLink.removeAttribute('aria-busy')
    }
  }

  preloadImage (src) {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = () => resolve(img)
      img.onerror = () => reject(new Error('Image load failed'))
      img.src = src
    })
  }

  async openPhotoModal (photoLink, src) {
    if (!src) return

    const modal = document.querySelector('.reusable-modal')
    if (!modal) return

    const modalBody = modal.querySelector('.reusable-modal__body')
    if (!modalBody) return

    this.setPhotoLinkLoading(photoLink, true)

    try {
      await this.preloadImage(src)
    } catch (err) {
      this.setPhotoLinkLoading(photoLink, false)
      window.open(src, '_blank', 'noopener,noreferrer')
      return
    }

    this.setPhotoLinkLoading(photoLink, false)

    modalBody.innerHTML = `
      <div class="product-reviews__photo-modal flex items-center justify-center">
        <img src="${escapeHtml(src)}" alt="" class="product-reviews__photo-modal-img max-w-full max-h-[80vh] object-contain mx-auto">
      </div>
    `

    window.dispatchEvent(
      new CustomEvent('open:modal', {
        detail: {
          padding: 'none',
          headerClassAdd: ['absolute', 'top-0', 'left-0', 'right-0', 'z-20', 'block'],
          headerClassRemove: ['border-b', 'mb-4', 'pb-2', 'grid'],
          closeClassAdd: ['absolute', 'top-4', 'right-4', 'z-20', 'bg-white', 'rounded-full', 'p-1'],
          closeClassRemove: [],
        },
      }),
    )
  }
}

if (!customElements.get('tb-product-reviews')) {
  customElements.define('tb-product-reviews', TbProductReviews)
}
